import { render, staticRenderFns } from "./IconWorkouts.vue?vue&type=template&id=2a8ed843&scoped=true"
import script from "./IconWorkouts.vue?vue&type=script&lang=js"
export * from "./IconWorkouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8ed843",
  null
  
)

export default component.exports